<template>
    <div v-if="activeCompany && activeCompany.id">
        <CompaniesAddStationModal v-if="addStationModalOpen" @close="setAddStationModal(false)"/>
        <div class="d-flex justify-end mb-2">
            <v-btn class="ma-2" color="primary" @click="setAddStationModal(true)">
                + Add New Station
            </v-btn>
        </div>
        <v-card class="ma-3 pa-5">
            <v-row class="pa-3" justify="space-between">
                <h3>{{ activeCompany.value }}</h3>
                <v-spacer/>

            </v-row>
            <v-divider class="my-3"/>

            <v-text-field v-model="activeCompany.value"
                          :loading="loading"
                          label="Company name"
                          placeholder="Company name"
                          type="text"/>

            <v-text-field v-model="activeCompany.client_nrs"
                          :disabled="!activeCompany.station_locations.length"
                          :error="!activeCompany.station_locations.length"
                          :error-messages="!activeCompany.station_locations.length ? ['There must be at least 1 station location to add client_nr. Please add it manually.'] : []"
                          :loading="loading"
                          label="Client numbers"
                          placeholder="Client numbers"
                          type="text"/>

            <v-switch v-model="activeCompany.has_prediction_rights" color="success"
                      label="Has prediction rights"></v-switch>

            <v-btn class="mt-3" color="primary" @click="handleSaveClick">Save</v-btn>

        </v-card>
        <v-card class="ma-3 pa-5">
            <v-card-title>
                <span class="text-h5">Station Locations</span>
            </v-card-title>
            <v-card-text>
                <CompaniesListStationLocation v-if="activeCompany.id" :company="activeCompany"/>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
//import CompaniesEdit from '../../components/companies/CompaniesEdit.vue';
import CompaniesListStationLocation from '../../components/companies/CompaniesListStationLocation.vue';
import CompaniesAddStationModal from '@/components/companies/CompaniesAddStationModal.vue';
import { mapActions, mapState } from 'vuex';

export default {
    name: 'CompaniesLayout',
    components: {CompaniesListStationLocation, CompaniesAddStationModal},
    data() {
        return {
            addStationModalOpen: false,
        };
    },
    computed: {
        ...mapState('company', ['activeCompany', 'loading']),
    },
    async mounted() {
        await this.fetchCompany(this.$route.params.id);
    },

    methods: {
        ...mapActions('company', ['fetchCompany', 'updateCompany']),
        handleSaveClick() {
            this.updateCompany(this.activeCompany);
        },
        setAddStationModal(isOpen) {
            this.addStationModalOpen = isOpen
        }
    },
};
</script>

<style scoped>

</style>